<template>
  <div>
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.tracksWorker'), $t('text.list')]"
      ></breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.workerIds"
              :placeholder="$t('menu.workers')"
              size="small"
              filterable
              clearable
              multiple
            >
              <el-option
                v-for="worker in workers"
                :key="worker.id"
                :label="worker.name"
                :value="worker.id"
              />
            </el-select>
          </el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <span class="float-right font10">表格数字代表： 共计/货号数 </span>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        id="recordsTable"
        row-id="id"
        :loading="loading"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          :title="$t('menu.workers')"
          field="name"
          width="70"
          fixed="left"
          align="center"
        >
          <template v-slot="{ row }">
            <span :class="row.voidAt != null ? 'deleted' : ''">
              {{ row.name }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('worker.serialNo')"
          width="80"
          fixed="left"
          align="center"
        >
        </vxe-table-column>

        <vxe-table-column
          v-for="phase of phases"
          :key="phase.id"
          :title="phase.name"
          width="70"
          align="center"
          v-bind="phase"
          :field="phase.name"
          show-header-overflow
          show-overflow="title"
        >
          <template v-slot="{ row }">
            <span v-if="computeCurrentWorkerPhase(row, phase)">
              <span v-if="computeCurrentPhase(row, phase) != null">
                {{ computeCurrentPhase(row, phase).totalQty }}/{{
                  computeCurrentPhase(row, phase).productNoQty
                }}
              </span>
            </span>
            <span v-else>--</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }} </span>条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Worker from "@/api/worker.js";
import Phase from "@/api/phase.js";
export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {},

  data() {
    return {
      Util: Util,
      sorter: {
        // sortBy: "workOrders_id",
        // sortIndicator: "desc",
      },
      narrows: [
        [
          {
            label: this.$t("user.voidInfo"),
            items: [
              {
                label: this.$t("authorizes.noVoid"),
                key: "invalidNo",
                condition: { invalid: "no" },
              },
              {
                label: this.$t("authorizes.void"),
                key: "invalidYes",
                condition: { invalid: "yes" },
              },
            ],
          },
        ],
      ],
      initFilter: "invalidNo",
      searchForm: {
        workerIds: [],
      },
      Util: Util,
      workers: [],
      phases: [],
    };
  },
  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    axios.all([Worker.findByTenantId(), Phase.findByTenantId()]).then(
      axios.spread(function (workers, phases) {
        if (workers.status === 200) {
          self.workers = workers.data;
        } else {
          self.sysError();
        }
        if (phases.status === 200) {
          self.phases = phases.data;
        } else {
          self.sysError();
        }
      })
    );
  },
  methods: {
    computeCurrentWorkerPhase(row, currentPhase) {
      const obj = row.workerPhases.find((wp) => wp.phaseId == currentPhase.id);
      if (obj != null) {
        return true;
      }
      return false;
    },
    computeCurrentPhase(row, currentPhase) {
      if (row.phaseCounts && row.phaseCounts.length !== 0) {
        const currentPhaseCounts = row.phaseCounts.filter(
          (p) => p.phaseId === currentPhase.id
        );
        if (currentPhaseCounts.length !== 0) {
          return currentPhaseCounts[0];
        }
        return null;
      }
      return null;
    },
    //======
    dataProvider(params) {
      return Worker.trackingSearch(params);
    },
  },
};
</script>
<style>
.color-explain {
  height: 10px;
  width: 40px;
  border: 1px solid #eee;
  margin-top: 7px;
  margin-right: 5px;
}
.bg-green {
  background: #67c23a;
  color: #fff;
}
.bg-orange {
  background: #eb9e05;
  color: #fff;
}
.bg-grey {
  background: #fafafa;
}

.bg-green-delay {
  background: #67c23a;
  color: #fff;
}
.bg-orange-delay {
  background: #eb9e05;
  color: #fff;
}
.bg-grey-delay {
  background: #fafafa;
}

.warning-row {
  background: rgba(248, 218, 174, 1);
}

.special-row {
  background: rgba(255, 190, 194, 1);
}

/* .vxe-table.size--mini .vxe-body--column:not(.col--ellipsis),
.vxe-table.size--mini .vxe-footer--column:not(.col--ellipsis),
.vxe-table.size--mini .vxe-header--column:not(.col--ellipsis) {
  padding: 0px 0;
}

.vxe-table .vxe-cell {
  white-space: pre-line;
  word-break: break-all;
  padding-left: 2px;
  padding-right: 2px;
  font-size: 12px;
} */
</style>
